import { render, staticRenderFns } from "./ItemCollectionLayout.vue?vue&type=template&id=d4322d00&scoped=true"
import script from "./ItemCollectionLayout.vue?vue&type=script&lang=js"
export * from "./ItemCollectionLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4322d00",
  null
  
)

export default component.exports